import { db } from '../firebase';
import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where,
  writeBatch,
  increment,
} from 'firebase/firestore';

const TODOS = 'todos';

function userTodosQuery(userId) {
  // Avoid composite index requirement; we'll sort client-side
  return query(
    collection(db, TODOS),
    where('userId', '==', userId),
  );
}

export const todoService = {
  subscribeUserTodos(userId, cb) {
    return onSnapshot(userTodosQuery(userId), (snap) => {
      const res = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      cb(res);
    });
  },

  async addTodo(userId, { title, priority = 'P2', tags = [], dueAt = null, estimatePomos = 0 }) {
    return addDoc(collection(db, TODOS), {
      userId,
      title,
      priority,
      status: 'open',
      actualPomos: 0,
      estimatePomos,
      tags,
      dueAt,
      order: Date.now(),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  },

  async updateTodo(userId, id, patch) {
    const ref = doc(db, TODOS, id);
    const data = { ...patch, updatedAt: serverTimestamp() };
    return updateDoc(ref, data);
  },

  async incrementActualPomos(userId, id, amount = 1) {
    const ref = doc(db, TODOS, id);
    return updateDoc(ref, { actualPomos: increment(amount), updatedAt: serverTimestamp() });
  },

  async reorder(userId, orderedIds) {
    const batch = writeBatch(db);
    orderedIds.forEach((id, idx) => {
      const ref = doc(db, TODOS, id);
      batch.update(ref, { order: idx, updatedAt: serverTimestamp() });
    });
    return batch.commit();
  },

  async addChecklistItem(userId, id, item) {
    // client should build full checklist array and call updateTodo, this is a convenience
    const ref = doc(db, TODOS, id);
    return updateDoc(ref, { checklist: item, updatedAt: serverTimestamp() });
  },
};
